import { render } from "./Snackbar.vue?vue&type=template&id=7d15d132&scoped=true&lang=pug"
import script from "./Snackbar.vue?vue&type=script&lang=ts"
export * from "./Snackbar.vue?vue&type=script&lang=ts"

import "./Snackbar.vue?vue&type=style&index=0&id=7d15d132&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d15d132"

export default script